export type { InjectedConnectFieldsSupportProps } from './with-connect-fields-support';
export { default as withConnectFieldSupport } from './with-connect-fields-support';
